import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              用户口碑
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              听听追剧达人们怎么说
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {commentsData.map((comment) => (
              <div
                key={comment.id}
                className="bg-background-50 rounded-lg border border-secondary-200/70 p-5 md:p-6"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-500">
                    <i className={`${comment.avatar} text-lg`}></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                    <div className="flex items-center gap-0.5 mt-0.5">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`text-xs ${i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                        ></i>
                      ))}
                    </div>
                  </div>
                  <span className="ml-auto text-xs text-foreground-400 whitespace-nowrap">{comment.time}</span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  &ldquo;{comment.content}&rdquo;
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}